// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__znzr2","noInteraction":"EventWrapper_noInteraction__1tdej","pointerPassthrough":"EventWrapper_pointerPassthrough__27cUS"};